'use strict';
(function () {
  angular.module('pentaApp').controller('storeProductSelection.controller', controller);
  controller.$inject = ['$scope', '$filter', 'flyer.resource', 'product.resource', 'productCategory.resource', '$timeout', 'order.resource', '$q', 'promotion.resource', 'image.resource', 'posTable.resource', 'callEmployee.resource', 'hq.socket', 'bottomLogin.modal'];
  function controller($scope, $filter, flyerResource, productResource, productCategoryResource, $timeout, orderResource, $q, promotionResource, imageResource, posTableResource, callEmployeeResource, hqSocket, loginModal) {
    var _controller = Date.now();
    /// METHODS
    $scope.mainResource = flyerResource;
    $scope.scrollToCategory = scrollToCategory;
    $scope.homeContents = null;
    $scope.selectProduct = selectProduct;
    $scope.approveClient = approveClient;
    $scope.toTracking = toTracking;
    $scope.flyerResource = flyerResource;
    $scope.goToCart = goToCart;
    $scope.changeAddress = changeAddress;
    $scope.validateAddress = validateAddress;
    $scope.clearAddress = clearAddress;
    $scope.resetDeliveryData = resetDeliveryData;
    $scope.saveCheckoutMethod = saveCheckoutMethod;
    $scope.changeRouter = changeRouter;
    $scope.login = login;
    $scope.filterView = filterView;
    $scope.findGoogleMapsAddress = findGoogleMapsAddress;
    $scope.callEmployeeLogin = callEmployeeLogin;
    $scope.imageResource = imageResource;
    $scope.reloadToTable = reloadToTable;
    $scope.openCheckoutMethodModal = openCheckoutMethodModal;
    $scope.canChangeMethod = canChangeMethod;

    /// VARS
    if (window.queryStrings.router) $scope.$root.defaultRouter = window.queryStrings.router;
    $scope.showOrder = window.__showOrder;
    $scope.options = { clickableIcons: false, disableDefaultUI: true };
    $scope.usedDeliveryArea;
    $scope.table;
    $scope.categories = [];
    $scope.products = [];
    $scope.defaultRouterObject;
    $scope.recommendations = [];
    //$scope.showLogin = true;
    $scope._deliveryData = { coordinates: {} }
    $scope.atLeastOneRouterTakeAway = !!$scope.$root.routers.filter(function (f) { return f.pwaCheckoutMethods && f.pwaCheckoutMethods.takeAway }).length;
    $scope.atLeastOneRouterAutoservice = !!$scope.$root.routers.filter(function (f) { return f.pwaCheckoutMethods && f.pwaCheckoutMethods.autoservice }).length;
    $scope.atLeastOneRouterDelivery = !!$scope.$root.routers.filter(function (f) { return f.pwaCheckoutMethods && f.pwaCheckoutMethods.delivery }).length;
    $scope.atLeastOneRouterLocal = !!$scope.$root.routers.filter(function (f) { return f.pwaCheckoutMethods && f.pwaCheckoutMethods.local }).length;
    $scope.addressPredictions = [];
    $scope.regularBussinessHours = [];
    $scope.specialBussinessHours = [];
    $scope.localProductsAdded = appNavigator.topPage && appNavigator.topPage.data && appNavigator.topPage.data.localProductsAdded;
    $scope.$root.ordersInProcess = [];
    $scope.cIndex = 0;
    var selectProductAfterConfirmCheckoutMethod;
    var confirmCheckoutMethod;
    var gmapsAutoService = new google.maps.places.AutocompleteService();
    var gmapsGeocoder = new google.maps.Geocoder();
    var userPosition = {};
    var localOrders;
    var enableGlobalRouter = window.profile && window.profile.enterprise && window.profile.enterprise.pwaConfig && window.profile.enterprise.pwaConfig.storeConfig && window.profile.enterprise.pwaConfig.storeConfig.enableGlobal;
    // WATCHERS
    $scope.$on('$destroy', onDestroy.bind(null, _controller));
    //$scope.$on('defaultRouter', getRouterStoreData);
    window.addEventListener("resize", carouselHeight);
    hqSocket.on('reconnect', onUpsertOrder);

    /// INIT
    init()



    /////////////////////

    function init() {
      /// getPendingOrders guarda $scope.$root.ordersInProcess (ordenes abiertas no método LOCAL) 
      /// y localOrders (ordenes abiertas método LOCAL)
      getPendingOrders(function () {
        /// getCurrentOrderOrNew utiliza localOrders
        getCurrentOrderOrNew(function (order) {
          $scope.$root.currentOrder = order;
          $scope.$root.defaultRouter = order.router;
          var robj = $scope.$root.routers.filter(function (f) { return f._id === $scope.$root.defaultRouter })[0];
          if (order.checkoutMethod === 'LOCAL') {
            hqSocket.on('ORDER_UPSERT', onUpsertOrder);
            getTable(order.table)
            ///// DISPARO ENCUESTA
            if (robj.customInquery && robj.customInquery.beforeLocal && !$scope.$root.currentOrder.customInqueryResponses)
              triggerCustomInquery(robj.customInquery.beforeLocal)
          }
          if (order.checkoutMethod === 'AUTOSERVICE') {
            if (robj.customInquery && robj.customInquery.beforeAutoservice && !$scope.$root.currentOrder.customInqueryResponses)
              triggerCustomInquery(robj.customInquery.beforeAutoservice)
          }
          if (order.checkoutMethod === 'DELIVERY' && localStorage && appStorage.get('storeDeliveryData')) {
            $scope._deliveryData = JSON.parse(appStorage.get('storeDeliveryData'))
            if (!$scope._deliveryData.coordinates) $scope._deliveryData.coordinates = {};
            changeAddress(); /// changeAddress opera sobre $scope.$root.currentOrder, por ende tiene que hacerse luego de setearala
          }
          getRouterStoreData()
        })
      })
    }

    function triggerCustomInquery(customInquery) {
      $scope.$root.openCustomInquery(customInquery, {
        callback: function (toSave) {
          if (!profile._id)
            Object.defineProperty($scope.$root.currentOrder, 'customInqueryResponses', { value: toSave, enumerable: false, writable: true })
        },
        dontSave: !profile._id,
        lastResponseDelta: 1000 * 60 * 60 * 24
      })
    }

    function getTable(table) {
      if (!table) return;
      if ($scope.$root.defaultRouter) {
        var router = $scope.$root.routers.filter(function (f) { return f._id === $scope.$root.defaultRouter })[0];
        if (router.readOnlyStore) return;
      }
      $scope.table = posTableResource.get({ _id: table, _controller: _controller })
    }

    function getCurrentOrderOrNew(done) {
      /// si hay una orden activa,  no inicializo la orden de nuevo
      /// Si es local la orden se puede modificar desde backend, por ende conviene hacer que se actualice cada vez
      if ((!localOrders || !localOrders.length) && $scope.$root.currentOrder && $scope.$root.currentOrder.products && $scope.$root.currentOrder.products.length)
        return done($scope.$root.currentOrder)

      //// Creo una orden plantilla, para quienes tengan que crear una nueva orden
      var orderTemplate = {
        products: [],
        router: $scope.$root.defaultRouter,
      }

      ///// Caso checkoutMethod: LOCAL (comer en el local)
      // método LOCAL con order de mesa ya abierta
      if (localOrders && localOrders.length) {
        var localOrder = localOrders[0]
        // Necesito recuperar los productos agregados que no fueron a db todavía
        if ($scope.$root.currentOrder && $scope.$root.currentOrder.checkoutMethod === 'LOCAL' && $scope.$root.currentOrder.table === localOrder.table)
          localOrder.products = localOrder.products.concat($scope.$root.currentOrder.products.filter(function (f) { return f._new }))
        return done(localOrder);
      }
      // método LOCAL con link
      if (window.queryStrings.table) {
        orderTemplate.table = window.queryStrings.table
        orderTemplate.checkoutMethod = 'LOCAL'
        orderTemplate.clientCount = 2;
        return done(orderTemplate)
      }

      ///// Caso checkoutMethod: DELIVERY, AUTOSERVICE, TAKEAWAY
      else {
        var savedMeth = localStorage ? appStorage.get('storeCheckoutMethod') : undefined;
        var routerMethods = routerCheckoutMethods(orderTemplate.router);
        if (enableGlobalRouter) orderTemplate.checkoutMethod = 'TAKEAWAY';
        /// Caso forzado desde queryString
        else if (window.queryStrings.checkoutMethod)
          orderTemplate.checkoutMethod = window.queryStrings.checkoutMethod;
        /// Caso guardado en localstorage (después de elegirlo al menos una vez)
        else if (savedMeth && routerMethods.includes(savedMeth)) orderTemplate.checkoutMethod = savedMeth;
        /// Caso cliente nuevo
        else {
          /// Voy por orden de prioridad, según los métodos que tenga el router
          if (routerMethods.includes('DELIVERY')) orderTemplate.checkoutMethod = 'DELIVERY'
          else if (routerMethods.includes('TAKEAWAY')) orderTemplate.checkoutMethod = 'TAKEAWAY'
          else if (routerMethods.includes('AUTOSERVICE')) orderTemplate.checkoutMethod = 'AUTOSERVICE'
          else if (routerMethods.includes('LOCAL')) orderTemplate.checkoutMethod = 'LOCAL'
          /// Si nada se sumple, lo consulto
        }
        /// Si el router está forzado o hay un solo router y hay un solo método, entonces no hace falta preguntar nada excepto que sea carta, ya que tiene que escanear
        var router = $scope.$root.routers.find(function (f) { return f._id === orderTemplate.router });
        if ((window.queryStrings.router || $scope.$root.routers.length === 1) && routerMethods.length === 1 && (routerMethods[0] !== 'LOCAL' || router.readOnlyStore))
          $scope.askMethod = false;
        /// Caso contrario pregunto, ya que puede querer elegir otra sucursal u otro método
        else
          $scope.askMethod = enableGlobalRouter ? false : true;

        done(orderTemplate)
      }
    }

    function getRouterStoreData() {
      $scope.defaultRouterObject = $scope.$root.defaultRouter !== 'global' ? $scope.$root.routers.filter(function (f) { return f._id === $scope.$root.defaultRouter })[0] : $scope.$root.globalRouter;
      setBusinessHours();
      getUserGeoData();
      setUserOrRouterCoordinates();
      refreshFlyers();
      refreshProducts();
      carouselHeight();
    }

    function setBusinessHours() {
      if ($scope.defaultRouterObject.businessHours && $scope.defaultRouterObject.businessHours.length) {
        $scope.regularBussinessHours = $scope.defaultRouterObject.businessHours.filter(function (f) { return !f.start })
        $scope.specialBussinessHours = $scope.defaultRouterObject.businessHours.filter(function (f) { return !!f.start })
      }
    }

    function refreshPromotions() {
      promotionResource.query({ _controller: _controller }, function (promotions) {
        $scope.products.forEach(function (p) {
          window.setPromotionPrice(p, promotions, $scope.defaultRouterObject);
        })
      })
    }

    function getUserGeoData() {
      if (profile._id && navigator.geolocation && navigator.geolocation.getCurrentPosition)
        navigator.geolocation.getCurrentPosition(function (position) {
          userPosition.latitude = position.coords.latitude;
          userPosition.longitude = position.coords.longitude;
        });
    }

    var carouselTimeout;
    function carouselHeight() {
      if (!carouselTimeout)
        carouselTimeout = $timeout(function () {
          var div = $('.carousel');
          div.css('height', div.width() * 0.4);
          carouselTimeout = null;
        }, 200)
    }

    function refreshFlyers() {
      flyerResource.query({ _controller: _controller, destination: 'APP-STORE' }, function (flyers) {
        $scope.homeContents = flyerFilter(flyers, $scope.$root.defaultRouter);
        $scope.homeContents.forEach(function(f){
          var mediaType = f.mediaType.toLowerCase();
          var translatedImage = mediaType === 'image' && $filter('language')(f,'image');
          f._imageUrl = translatedImage ? imageResource.getFileUrl(translatedImage, 'image') : flyerResource.getFileUrl(f._id, 'image');
        })
        if (!$scope.homeContents.length) {
          $scope.homeContents.push({
            mediaType: 'IMAGE',
            directUrl: '/frontend/static/img/banner.jpg',
            match: {}
          })
        }
        $scope.$root.carouselAutoscroll($scope, $scope.carousel, $scope.homeContents)
      })
    }

    function refreshProducts() {
      productCategoryResource.query({ _controller: _controller }, function (categories) {
        productResource.query({
          _controller: _controller,
          router: $scope.$root.defaultRouter,
          checkoutMethod: $scope.$root.currentOrder.checkoutMethod,
          _select: ['properties', 'masterProduct', 'stamp'],
        }, function (data) {
          $scope.products = data
          data = data.sort(function (a, b) { return (a.properties.sortIndex || Infinity) - (b.properties.sortIndex || Infinity) })
          refreshPromotions();
          $scope.toSearchProducts = data.filter(function (p) {
            return isValidProduct(p, $scope.$root.currentOrder.checkoutMethod) &&
                   p.properties && p.properties.categories && 
                   p.properties.categories.find(function (c) { return categories.find(function (c2) { return c._id === c2._id })
            })
          })
          /// Hago links imgs
          data.forEach(function (e) {
            if (!e.masterProduct && !e.router) e.masterProduct = e._id; //- Esto sirve para Sucursal Global, para obtener la imagen del producto.
            if (!e._image) Object.defineProperty(e, '_image', { writable: true });
            e._image = '/progressiveApp/api/productMedia?product=' + e.masterProduct + '&enterprise=' + window.enterprise;
          })
          categories.forEach(function (category) {
            category.products = $scope.products.filter(function (f) {
              return isValidProduct(f, $scope.$root.currentOrder.checkoutMethod) &&
                     f.properties.categories && 
                     f.properties.categories.find(function (d) { return d._id === category._id })
            })
          })
          //// Categoría recomendados
          var recommendationsCategory = categories.filter(function (f) { return f.name === 'Recomendados' })
          if (recommendationsCategory.length) $scope.recommendations = recommendationsCategory[0].products;
          ////
          categories = categories.filter(function (f) { return f.name !== 'Recomendados' })
          categories.forEach(function (f) {
            if (!f.translation || !f.translation.length) return;
            f.image = $filter('language')(f, 'image');
          })
          $scope.categories = buildCategoryTree(categories);
          ///

          /// Esta bandera se setea si el usuario intentó seleccionar un producto
          /// y le faltaba confirmar el checkoutMethod, esto lo setea selectProduct
          if (selectProductAfterConfirmCheckoutMethod) {
            var p = $scope.products.find(function (product) {
              return product.masterProduct && product.masterProduct === selectProductAfterConfirmCheckoutMethod.masterProduct
            })
            selectProductAfterConfirmCheckoutMethod = undefined;
            if (p) selectProduct(p);
            else ons.notification.alert({
              title: i18next.t('Atención'),
              message: i18next.t('El producto seleccionado ya no está disponible para el método de entrega y sucursal seleccionada')
            })
          }
        })
      })
    }

    function isValidProduct(product, checkoutMethod){
      return product.properties &&
              product.properties.forSale &&
              product.properties.target &&
              product.properties.target.pwa &&
              product.properties.target.pwa.visible &&
              (checkoutMethod === 'LOCAL' && product.properties.target.pwa.local ||
               checkoutMethod === 'DELIVERY' && product.properties.target.pwa.delivery ||
               checkoutMethod === 'AUTOSERVICE' && product.properties.target.pwa.autoservice ||
               checkoutMethod === 'TAKEAWAY' && product.properties.target.pwa.takeAway)
    }

    function filterView(categories, products, parentCategory) {
      window.appNavigator.pushPage('store/storeProductFilter/storeProductFilter.jade', {
        data: {
          categories: categories,
          products: products,
          parentCategory: parentCategory,
          selectProductFunction: selectProduct,
          onClose: Function.prototype
        }
      });
    }
    function selectProduct(product) {
      if (!canBuy(product)) return false;
      window.appNavigator.pushPage('store/storeProductPersonalization/storeProductPersonalization.jade', {
        data: { productId: product._id, onClose: Function.prototype }
      });
      return true;
    }


    function canBuy(product) {
      //// Si el usuario está logueado
      //if (!profile._id) {
      //$scope.showLogin = true;
      //return false;
      //}

      //// Si la orden está pagada no se pueden agregar productos, esto aplica para el caso checkoutMethod: LOCAL
      if ($scope.$root.currentOrder && $scope.$root.currentOrder.payed) {
        ons.notification.alert(i18next.t('No puedes agregar productos a una orden que ya pagaste, solicita al personal de atención que complete tu orden para iniciar una nueva'), { title: 'Problema' });
        return false;
      }

      //// Pido confirmar el método
      if (confirmCheckoutMethod) {
        confirmCheckoutMethod = false;
        $scope.askMethod = true
        selectProductAfterConfirmCheckoutMethod = product;
        return false;
      }

      var disabledReason = routerDisabledReason($scope.defaultRouterObject, $scope.$root.currentOrder);
      if (disabledReason) {
        switch (disabledReason) {
          case 'DISABLED-STORE':
            ons.notification.alert(i18next.t('Lo sentimos, por el momento tuvimos que cerrar el local'), { title: i18next.t('Problema') });
            return false;
          case 'INVALID-CHECKOUT-METHOD':
            selectProductAfterConfirmCheckoutMethod = product;
            $scope.askMethod = true;
            return false;
          case 'TAKEAWAY-DISABLED':
            ons.notification.alert(i18next.t('Lo sentimos, momentáneamente tuvimos que deshabilitar el retiro por sucursal. Elegí otro método de entrega.'), { title: 'Problema' });
            return false;
          case 'DELIVERY-DISABLED':
            ons.notification.alert(i18next.t('Lo sentimos, momentáneamente tuvimos que deshabilitar el delivery. Elegí otro método de entrega.'), { title: 'Problema' });
            return false;
          case 'NO-BUSINESS-HOURS':
            $scope.showClosed = true;
            return false;
          case 'ROUTER-CLOSED':
            if (!$scope.$root.currentOrder.scheduleForNextOpened) {
              closedModal(product);
              return false;
            }
        }
      }

      //// Si es válida la data del método de entrega
      if ($scope.$root.currentOrder.checkoutMethod === 'DELIVERY' && (!$scope.$root.currentOrder.deliveryData || !$scope.$root.currentOrder.deliveryData.address)) {
        selectProductAfterConfirmCheckoutMethod = product;
        $scope.askMethod = true;
        return;
      }

      return true
    }

    function onDestroy(_controller) {
      window.removeEventListener("resize", carouselHeight);
      hqSocket.removeListener('ORDER_UPSERT', onUpsertOrder)
      hqSocket.removeListener('reconnect', onUpsertOrder);
      $scope.$root.abortRequests(_controller);
    }


    function closedModal(product) {
      $scope.showClosed = true;
      var now = moment();
      $scope.closedModal = {
        //// buttons
        ok: function () {
          $scope.showClosed = false;
        }
      }

      if (!$scope.defaultRouterObject.allowScheduleWhenClosed) return;

      //// calculo el horario para programar
      var now = new Date();
      var currentMillis = now.getHours() * 3600000 + now.getMinutes() * 60000 + now.getSeconds() * 1000 + now.getMilliseconds();
      var bHours = $scope.defaultRouterObject.businessHours
      var cOrder = $scope.$root.currentOrder;
      var nextOpened;
      var date = moment().add('days', -1)
      for (var i = 0; i < 7; i++) {
        date.add('days', 1)
        nextOpened = bHours.filter(function (f) {
          /// Si tiene método y no coincide, entonces ni lo testeo
          if (f.checkoutMethod && f.checkoutMethod !== cOrder.checkoutMethod) return false;
          /// Si no tiene método y hay otro con método para el mismo dow, entonces no vale
          if (!f.checkoutMethod && bHours.filter(function (k) { return f.dow === k.dow && k.checkoutMethod === cOrder.checkoutMethod }).length) return false;
          /// Si es el mismo día y ya pasó openHour, este segmento no cuenta
          if (i === 0 && currentMillis > f.openHour) return false;
          return ((!f.dow && f.dow !== 0) || f.dow == date.day()) &&
            ((!f.start && !f.end) || (now >= f.start && now <= f.end))
        }).sort(function (a, b) {
          return b.openHour - a.openHour;
        })[0]
        if (nextOpened) break;
      }
      //// Si está abierto agrego la función schedule, esto hace que se vea el botón programar
      if (nextOpened)
        $scope.closedModal.schedule = function () {
          $scope.showClosed = false;
          $scope.$root.currentOrder.scheduleForNextOpened = {
            from: moment(date).set({
              hour: 0, minute: 0, second: 0,
              millisecond: nextOpened.openHour + ($scope.defaultRouterObject.pwaMeanWait ? $scope.defaultRouterObject.pwaMeanWait * 60 * 1000 : 0)
            }).toDate(),
            //to: moment(date).set({hour:0,minute:0,second:0,millisecond: nextOpened.closeHour}).toDate()
          }
          selectProduct(product);
        }
    }

    function toTracking(order) {
      window.appNavigator.pushPage('store/storeTracking/storeTracking.jade', { data: { order: order, onClose: Function.prototype } });
    }

    function goToCart() {
      window.appNavigator.resetToPage('store/storeCart/storeCart.jade', { data: { onClose: Function.prototype } });
    }

    function changeAddress() {
      if ($scope.$root.currentOrder.checkoutMethod !== 'DELIVERY') return;
      if (localStorage) appStorage.set('storeDeliveryData');
      if (!$scope._deliveryData.address || !$scope._deliveryData.buildingType || !$scope._deliveryData.coordinates || !$scope._deliveryData.coordinates.latitude)
        return resetDeliveryData();
      $scope.$root.currentOrder.deliveryData = JSON.parse(JSON.stringify($scope._deliveryData));
      $scope.askAddress = false;
      $scope.invalidAddress = false;

      //- Se Verifica que haya almenos un Router que llegue a la direccion.
      var validRouters = routersForAddress($scope.$root.routers, $scope.$root.currentOrder)
      if (!validRouters.length) {
        $scope.invalidAddress = true;
        return resetDeliveryData();
      }
      validRouters.sort(function (a, b) { return a.distance - b.distance })
      var openedRouters = validRouters.filter(function (f) { return !routerDisabledReason(f.router, $scope.$root.currentOrder) });
      //- Si hay algun router abierto, se elije el mas cercano abierto, sino se elije el mas cercano de los routers validos.
      var validRouter = openedRouters.length ? openedRouters[0] : validRouters[0];

      $scope.$root.defaultRouter = validRouter.router._id;
      $scope.$root.currentOrder.router = validRouter.router._id;
      $scope.$root.currentOrder.deliveryArea = validRouter.deliveryArea._id;
      $scope.usedDeliveryArea = validRouter.deliveryArea;
      if (localStorage) appStorage.set('storeDeliveryData', JSON.stringify($scope.$root.currentOrder.deliveryData));
    }

    //- Esta function devuelve un array:
    // [
    //   {
    //     router: Object,
    //     distance: Number,
    //     deliveryArea: Object
    //   }
    // ]
    function routersForAddress(routers, currentOrder) {
      if (!routers || !routers.length || !currentOrder) return [];
      var currentLatitude = currentOrder.deliveryData.coordinates.latitude;
      var currentLongitude = currentOrder.deliveryData.coordinates.longitude;
      if (!currentLatitude || !currentLongitude) return [];
      var currentPoint = new google.maps.LatLng(currentLatitude, currentLongitude);
      var defaultRouterDistance = 10000;//- Distancia por defecto en caso de que no tenga bien seteada la posición, revisar este valor (ahora 10km)
      var currentRouterDistance = null;
      var results = [];
      routers.forEach(function (router) {
        if (!router.deliveryAreas || !router.deliveryAreas.length || !router.pwaCheckoutMethods || !router.pwaCheckoutMethods.delivery) return false;
        return router.deliveryAreas.find(function (dArea) {
          if (!dArea.polygon || dArea.disabled) return false;
          dArea.polygon.forEach(function (p) { p.lat = p.latitude; p.lng = p.longitude })
          var area = new google.maps.Polygon({ paths: dArea.polygon });
          if (google.maps.geometry.poly.containsLocation(currentPoint, area)) {
            //- Si tiene los datos seteo la distancia, si no, la distancia es la por defecto.
            if (router.geolocalization && router.geolocalization.coordinates && router.geolocalization.coordinates.length)
              currentRouterDistance = getDistance(router.geolocalization.coordinates[0], router.geolocalization.coordinates[1], currentLatitude, currentLongitude)
            else currentRouterDistance = defaultRouterDistance;
            results.push({
              router: router,
              distance: currentRouterDistance,
              deliveryArea: dArea
            })
          }
        })
      })
      return results
    }

    function resetDeliveryData() {
      $scope.askAddress = false;
      $scope.$root.currentOrder.deliveryData = undefined;
      $scope._deliveryData = { coordinates: {} }
      setUserOrRouterCoordinates();
      saveCheckoutMethod();
    }

    function setUserOrRouterCoordinates() {
      if (!$scope._deliveryData.coordinates.longitude) {
        ///// Si tengo permisos de datos de posición de usuario
        if (userPosition && userPosition.latitude) {
          /// Seteo los que están para que el mapa se pueda mostrar ya mismo
          $scope._deliveryData.coordinates.latitude = userPosition.latitude;
          $scope._deliveryData.coordinates.longitude = userPosition.longitude;

          /// Voy al api a intentar actualizar los datos
          if (navigator.geolocation && navigator.geolocation.getCurrentPosition)
            navigator.geolocation.getCurrentPosition(function (position) {
              userPosition.latitude = position.coords.latitude;
              userPosition.longitude = position.coords.longitude;
              $scope._deliveryData.coordinates.latitude = userPosition.latitude;
              $scope._deliveryData.coordinates.longitude = userPosition.longitude;
            });
        }
        ///// Si tengo ya la sucursal, si no, no lo seteo, después se hace cargo la función init
        else if ($scope.defaultRouterObject && $scope.defaultRouterObject.geolocalization && $scope.defaultRouterObject.geolocalization.coordinates) {
          $scope._deliveryData.coordinates.latitude = $scope.defaultRouterObject.geolocalization.coordinates[0];
          $scope._deliveryData.coordinates.longitude = $scope.defaultRouterObject.geolocalization.coordinates[1];
        }
      }
    }

    function getPendingOrders(done) {
      if (!profile._id) {
        if (done) done();
        return;
      }
      $q.all([
        orderResource.query({ _controller: _controller, _select: ['*'], 'queue.status_ne': 'null' }).$promise,
        orderResource.query({ _controller: _controller, _select: ['*'], 'delivery.status_ne': 'null' }).$promise,
      ]).then(function (results) {
        results[1].forEach(function (order) {
          if (results[0].find(function (f) { return f._id === order._id })) return;
          results[0].push(order);
        })
        $scope.$root.ordersInProcess = results[0].filter(function (f) { return f.checkoutMethod !== 'LOCAL' });
        if (window.queryStrings && window.queryStrings.order) {
          var reqOrder = $scope.$root.ordersInProcess.find(function (f) { return f._id === window.queryStrings.order })
          window.queryStrings.order = undefined;
          if (reqOrder) $timeout(function () { toTracking(reqOrder) }, 100)
        }
        localOrders = results[0].filter(function (f) { return f.checkoutMethod === 'LOCAL' });
        if (done) done()
      })
    }


    function scrollToCategory(category) {
      var categoryEl = document.getElementById(category.name.replace(' ', ''))
      if (categoryEl) categoryEl.scrollIntoView({ behavior: 'smooth' })
    }

    function getDistance(lat1, lon1, lat2, lon2) {
      var R = 6371; // Radius of the earth in km
      var dLat = deg2rad(lat2 - lat1);  // deg2rad below
      var dLon = deg2rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in km
      return d;
    }

    function buildCategoryTree(allCategories) {
      var toRet = allCategories.filter(function (f) { return !f.parent });
      toRet.forEach(function (item) { buildChilds(item) });
      return toRet;

      ///////
      function buildChilds(parent) {
        parent.nodes = allCategories.filter(function (f) { return f.parent === parent._id });
        parent.nodes.forEach(function (node) {
          node._parentArray = parent.nodes;
          buildChilds(node)
        });
        /// Una categoría está vacía si no tiene subcategorías o sus subcategorías están vacías 
        /// y a su vez no tiene productos
        if ((!parent.nodes.length || (parent.nodes.filter(function (f) { return f.empty }).length === parent.nodes.length)) && (!parent.products || !parent.products.length))
          parent.empty = true;
      }
    }

    function deg2rad(deg) {
      return deg * (Math.PI / 180)
    }

    function changeRouter() {
      var routers = null;
      if (enableGlobalRouter) {
        routers = $scope.$root.routers.filter(function (router) { return !router.hidden });
        routers.unshift($scope.$root.globalRouter)
      }
      window.appNavigator.pushPage("selectRouter/selectRouter.jade", {
        data: {
          routers: $scope.takeAwayRouters || routers,
          onClose: Function.prototype
        }
      });
    }

    function saveCheckoutMethod() {
      $scope.$root.currentOrder.router = $scope.$root.defaultRouter;
      if (localStorage && $scope.$root.currentOrder && $scope.$root.currentOrder.checkoutMethod)
        appStorage.set('storeCheckoutMethod', $scope.$root.currentOrder.checkoutMethod);

      getRouterStoreData()

    }

    function validateAddress(googlePlace) {
      if (!googlePlace || !googlePlace.title) return;
      setUserOrRouterCoordinates();
      $scope._addressLoading = true;
      $scope._invalidAddress = false;
      $scope._deliveryData.address = googlePlace.title;
      gmapsGeocoder.geocode({ 'address': googlePlace.title }, function (results) {
        $scope._addressLoading = false;
        if (!results.length || !results[0].types || !results[0].types.length || !results[0].formatted_address || !results[0].geometry || !results[0].geometry.location) return fail();
        if (!results[0].types.filter(function (f) { return (f === 'street_address' || f === 'premise' || f === 'subpremise') }).length) fail();
        $scope._deliveryData.formattedAddress = results[0].formatted_address;
        $scope._deliveryData.coordinates = { latitude: results[0].geometry.location.lat(), longitude: results[0].geometry.location.lng() };
        if (!$scope._deliveryData.coordinates.latitude || !$scope._deliveryData.coordinates.longitude) {
          setUserOrRouterCoordinates();
        }
        $scope._addressPlaceholder = undefined;
        if (!$scope.$$phase) $scope.$apply();
      })

      function fail() {
        $scope._invalidAddress = true;
        if (!$scope.$$phase) $scope.$apply();
      }
    }

    function clearAddress() {
      $scope.$broadcast('angucomplete-alt:clearInput', 'user-address');
      $scope._deliveryData.address = '';
      $scope._deliveryData.coordinates = {};
    }

    function findGoogleMapsAddress(input) {
      return $q(function (resolve, reject) {
        gmapsAutoService.getPredictions({ input: input }, function (data) {
          if (data) return resolve(data)
          resolve([{ description: input, _subtitle: i18next.t('(manual)') }])
        })
      });
    }

    function callEmployeeLogin() {
      if (!profile._id) {
        loginModal.open({ title: i18next.t('Debes iniciar sesión') })
          .then(function () {
            if (!profile._id) { ons.notification.alert(i18next.t('Debe identificarse para llamar al mozo'), { title: 'No se pudo completar' }); return }
            callEmployee()
          })
          .catch(function (err) {
            if (err) throw new PentaError(err)
          })
      } else {
        callEmployee()
      }
    }

    function callEmployee() {
      ons.notification.confirm({ message: i18next.t('¿Desea llamar al mozo?'), title: i18next.t('Llamar mozo'), cancelable: true }).then(function (result) {
        if (result < 1) return;
        callEmployeeResource.save({
          router: $scope.$root.currentOrder.router,
          table: $scope.$root.currentOrder.table,
          type: 'TABLE-NEEDS'
        }, function () {
          ons.notification.alert(i18next.t('Se ha llamado al personal de atención, por favor espere a ser atendido'), { title: i18next.t('Enviado') })
        })
      })
    }

    function onUpsertOrder(data) {
      if ($scope.$root && $scope.$root.currentOrder && $scope.$root.currentOrder._id === data) {
        orderResource.get({ _controller: _controller, _id: data, _select: ['queue.status', 'table', 'secondaryClients.*'] }, function (order) {
          $scope.$root.currentOrder.secondaryClients = order.secondaryClients;
          /// Cambio de mesa
          if (order.table !== $scope.$root.currentOrder.table) {
            $scope.$root.currentOrder.table = order.table;
            getTable(order.table)
            return;
          }
          /// Cierre de mesa
          if (order.queue && !order.queue.status) {
            ons.notification.alert({
              title: i18next.t('Mesa cerrada'),
              message: i18next.t('La mesa fue cerrada, para volver a abrirla, debe escanear de nuevo el código QR. Si abre la tienda nuevamente, preste atención al método de entrega, en la parte superior.')
            });
            window.queryStrings.table = undefined;
            $scope.$root.currentOrder = undefined;
            $scope.$root.openSection('home/home.jade')
          }
        })
      }
    }

    function approveClient(client, approved) {
      client.status = approved ? 'APPROVED' : 'REJECTED';
      orderResource.save({
        _controller: _controller,
        _id: $scope.$root.currentOrder._id,
        router: $scope.$root.currentOrder.router,
        approveClient: true,
        secondaryClients: $scope.$root.currentOrder.secondaryClients
      }, function () {
      })
    }

    function login() {
      $scope.$root.login({ onClose: function () { $scope.$root.openSection('./store/storeProductSelection/storeProductSelection.jade') } })
    }

    function reloadToTable(url) {
      window.location.href = url;
    }

    function routerDisabledReason(router, currentOrder) {
      if (!router) return true
      //// Me fijo si no está cerrada a la fuerza la sucursal
      if (router.overrides && router.overrides.disableStore) return 'DISABLED-STORE';
      //// Sin son válidos los metodos de entrega, esto es solo por si las dudas quedó guardado un método de entrega no válido
      if (!currentOrder || !router.pwaCheckoutMethods ||
        currentOrder.checkoutMethod === 'TAKEAWAY' && !router.pwaCheckoutMethods.takeAway ||
        currentOrder.checkoutMethod === 'DELIVERY' && !router.pwaCheckoutMethods.delivery) {
        return 'INVALID-CHECKOUT-METHOD'
      }
      //// Si alguno de los métodos está forzado
      if (router.overrides && currentOrder.checkoutMethod === 'TAKEAWAY' && router.overrides.disableTakeaway) return 'TAKEAWAY-DISABLED';
      if (router.overrides && currentOrder.checkoutMethod === 'DELIVERY' && router.overrides.disableDelivery) return 'DELIVERY-DISABLED';
      //// Si no tiene horarios de atención
      if (!router.businessHours || !router.businessHours.length) return 'NO-BUSINESS-HOURS';
      if (!routerOpened(router, currentOrder)) return 'ROUTER-CLOSED';
      return false
    }

    function routerOpened(router, currentOrder) {
      if (!router || !currentOrder) return false
      if (router.ignoreBusinessHoursInStore) return true;
      var currentDow = moment().utcOffset(router.utcOffset).day();
      $scope.currentDow = currentDow;
      var now = new Date();
      var currentMillis = now.getHours() * 3600000 + now.getMinutes() * 60000 + now.getSeconds() * 1000 + now.getMilliseconds();
      var bHours = router.businessHours;
      var cOrder = currentOrder;
      var opened = bHours.filter(function (f) {
        /// Si tiene método y no coincide, entonces ni lo testeo
        if (f.checkoutMethod && f.checkoutMethod !== cOrder.checkoutMethod) return false;
        /// Si no tiene método y hay otro con método para el mismo dow, entonces no vale
        if (!f.checkoutMethod && bHours.filter(function (k) { return f.dow === k.dow && k.checkoutMethod === cOrder.checkoutMethod }).length) return false;
        if (f.start) f.start = new Date(f.start);
        if (f.end) f.end = new Date(f.end);
        return ((!f.dow && f.dow !== 0) || f.dow == currentDow) &&
          (currentMillis >= f.openHour && currentMillis <= f.closeHour) &&
          ((!f.start && !f.end) || (now >= f.start && now <= f.end))
      }).sort(function (a, b) {
        return b.start ? 1 : -1;
      })[0]
      return opened;
    }

    // Si el router tiene un solo método, lo devuelve, si no, undefined
    function routerCheckoutMethods(routerId) {
      var methods = [];
      var router = $scope.$root.routers.find(function (f) { return f._id === routerId });
      if (router.pwaCheckoutMethods.takeAway) methods.push('TAKEAWAY')
      if (router.pwaCheckoutMethods.autoservice) methods.push('AUTOSERVICE')
      if (router.pwaCheckoutMethods.delivery) methods.push('DELIVERY')
      if (router.pwaCheckoutMethods.local) methods.push('LOCAL')
      return methods;
    }

    function openCheckoutMethodModal() {
      $scope.askMethod = ($scope.currentOrder.checkoutMethod !== 'LOCAL' || $scope.defaultRouterObject.readOnlyStore)
    }

    function canChangeMethod(defaultRouterObject) {
      if (!defaultRouterObject || !defaultRouterObject.pwaCheckoutMethods) return true;
      var checkoutMethods = Object.values(defaultRouterObject.pwaCheckoutMethods)
      if (checkoutMethods.filter(function (f) { return f }).length > 1) return true
      return false
    }
    //// FIN CONTROLLER
  }
})();
